/* ⚜️DD0 - Shipping (Checkpoints style)
   Replaces [start_date] / [end_date] in each checkpoint with dates computed
   client-side (today + min/max days), so it never breaks the CDN cache.
   [start_date] = today + data-min-days, [end_date] = today + data-max-days. */
class DD0CheckpointDates extends HTMLElement {
  connectedCallback() {
    const locale = this.dataset.locale || 'es';
    const format = this.dataset.format || 'long';
    const opts =
      format === 'long'
        ? { day: 'numeric', month: 'long' }
        : { day: '2-digit', month: '2-digit' };

    const fmt = (days) => {
      const d = new Date();
      d.setDate(d.getDate() + (parseInt(days, 10) || 0));
      try {
        return d.toLocaleDateString(locale, opts);
      } catch (e) {
        return d.toLocaleDateString('en', opts);
      }
    };

    this.querySelectorAll('[data-dynamic-date]').forEach((el) => {
      const text = el.dataset.text || '';
      if (text.indexOf('[start_date]') === -1 && text.indexOf('[end_date]') === -1) return;
      el.textContent = text
        .replace('[start_date]', fmt(el.dataset.minDays))
        .replace('[end_date]', fmt(el.dataset.maxDays));
    });
  }
}

if (!customElements.get('dd0-checkpoint-dates')) {
  customElements.define('dd0-checkpoint-dates', DD0CheckpointDates);
}
